import { Pipe, PipeTransform } from '@angular/core';
import { UsuariosPersonalService } from '../../services/usuarios-personal.service';

@Pipe({
    name: 'propiedadUsuario' // nombre del pipe en las directivas
})

export class PropiedadUsuarioPipe implements PipeTransform {

    constructor(public usuariosPersonalService:UsuariosPersonalService){}

    // Métdodo a implementar siempre
    transform(uid:string, propiedad:string):any{
        return this.usuariosPersonalService.obtenerPropiedadDeUsuario(uid, propiedad).valueChanges().take(1);
    }
}


// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/shared/pipes/propiedad-usuario.pipe.ts